import { fetchDatasource, fetchDatasourceChildren, fetchDatasourceMappings, triggerDataSourceMappingSync } from "actions/datasource";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Container, Grid, Icon } from "semantic-ui-react";
import { Image } from 'react-bootstrap';

import styles from "./browse.module.scss";

import TreeView from "react-accessible-treeview";
import ReactJson from 'react-json-view';

import GoogleDriveIcon from "./../../../../images/datasources/gdrive.png"
import DropBoxIcon from "./../../../../images/datasources/dropbox.png"
import BoxIcon from "./../../../../images/datasources/box.png"
import SharePointIcon from "./../../../../images/datasources/sharepoint.png"
import OneDriveIcon from "./../../../../images/datasources/onedrive.png"
import RssFeedIcon from "./../../../../images/datasources/rss.png"
import cx from "classnames";

function DataSourceBrowse({ account }) {

  const dispatch = useDispatch();

  const items = useSelector((state) => _.get(state, "datasources.browse.items"));
  const requests = useSelector((state) => _.get(state, "datasources.browse.requests"));
  const syncMapping = useSelector((state) => _.get(state, "datasources.browse.syncMapping"));
  const loading = useSelector((state) => _.get(state, "datasources.browse.loading"));

  const [metadata, setMetaData] = useState(null);

  const [data, setData] = useState([]);

  useEffect(() => {
    if (!_.isEmpty(items)) {
      setData(items);
    } else {
      setData([]);
    }
  }, [requests]);

  useEffect(() => {
    if (account) {
      dispatch(fetchDatasource({ accountId: account.id }));
    }
  }, [account]);


  function onNodeSelect(e) {
    let node = e.element;

    setMetaData(node.metadata);

    if (node.isBranch === false) {
      return;
    }

    if (node.dataSourceId === null || node.dataSourceId === undefined) {
      dispatch(fetchDatasourceMappings({ dataSourceId: node.id }));
    } else {
      dispatch(fetchDatasourceChildren({ dataSourceId: node.dataSourceId, dataSourceMappingId: node.dataSourceMappingId, parent: node.externalFolderId }));
    }
  }

  const handleSync = (element) => {
    dispatch(triggerDataSourceMappingSync({ id: element.dataSourceId, mappingId: element.dataSourceMappingId }));
  }

  const renderMapping = (element) => {
    return <div className={(styles.container)}>
      <div>
        <span className={(styles.statusText)}>{element.status}</span>
        <Button
          className={(styles.syncButton)}
          disabled={element.status === "SYNC_REQUESTED"}
          onClick={(e) => {
            e.preventDefault();
            handleSync(element);
          }}
          content={
            <>
              {syncMapping && syncMapping.loading && syncMapping.id === element.dataSourceMappingId ? <> <Icon loading name="loading sync" /> SYNCING </> : <> <Icon name="sync" /> SYNC</>}
            </>
          }
        />
      </div>

    </div>
  }

  const showIcon = (storageType) => {

    switch (storageType) {
      case "gdrive":
        return GoogleDriveIcon;
      case "dropbox":
        return DropBoxIcon;
      case "onedrive":
        return OneDriveIcon;
      case "box":
        return BoxIcon;
      case "sharepoint":
        return SharePointIcon;
      case "rss":
        return RssFeedIcon;

      default:
    }
    return null;
  }

  const renderDataSourceItem = (element) => {
    return <div className={(styles.datasource)}>
      <Image src={showIcon(element.storageType)} className={(styles.imageWidth)} /> &nbsp;
      <span className={(styles.datasourceName)}> {element.name}</span>
    </div>
  }

  const renderMappingItem = (element, isExpanded) => {

    return <div className={(styles.mappingContainer)}>
      {isExpanded ?
        <i className={cx("paperflite-minus", styles.addIcon)} /> :
        <i className={cx("paperflite-add", styles.addIcon)} />}
        <i className="fa fa-folder-o" />
        <span className={(styles.datasourceName)}> {element.name}</span>
      {element.status && <> {renderMapping(element)} </>}
    </div>

  }

  const renderFolderItem = (element, isExpanded) => {

    return <div className={(styles.folderContainer)}>
      {isExpanded ?
        <i className={cx("paperflite-minus", styles.addIcon)} /> :
        <i className={cx("paperflite-add", styles.addIcon)} />}
        <i className="fa fa-folder-o" />
      <span className={(styles.folderName)}> {element.name}</span>
    </div>
  }

  const renderFileItem = (element) => {
    return <div className={(styles.fileContainer)}>
      <i className={cx("fa fa-file-o", styles.addFile)} />
      <span className={(styles.folderName)}> {element.name}</span>
    </div>
  }

  const renderItem = (element, isExpanded) => {

    switch (element.type) {
      case "DATASOURCE":
        return renderDataSourceItem(element);
      case "MAPPING":
        return renderMappingItem(element, isExpanded);
      case "FOLDER":
        return renderFolderItem(element, isExpanded);
      default:
        return renderFileItem(element);
    }

  }

  const renderMessage = () => {
    if (loading === false && data && data.length === 0) {
      return <> No datasources </>
    } else if (loading === true && data && data.length === 0) {
      return <>fetching data sources</>
    }
  }

  return (
    <div>

      {renderMessage()}

      {!_.isEmpty(data) && <>
        <div className={styles.ide}>
          <Grid>
            <Grid.Row columns={2}>
              <Grid.Column width={10}>
                <TreeView
                  data={data}
                  aria-label="directory tree"
                  togglableSelect
                  clickAction="EXCLUSIVE_SELECT"
                  multiSelect
                  onNodeSelect={onNodeSelect}
                  nodeRenderer={({
                    element,
                    isBranch,
                    isExpanded,
                    getNodeProps,
                    level,
                    handleSelect,
                  }) => (
                    <div {...getNodeProps()}>

                      <div>
                        {renderItem(element, isExpanded)}
                      </div>

                    </div>
                  )}
                />
              </Grid.Column>
              <Grid.Column width={6}>
                {metadata && <ReactJson src={metadata} />}
              </Grid.Column>
            </Grid.Row>
          </Grid>


        </div>
      </>}



    </div>);
}

export default DataSourceBrowse;